"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTabId = void 0;
/**
 * Comprueba si existe un ID de pestaña almacenado en sessionStorage.
 * @returns {boolean} - true si existe, false si no.
 */
const existsTabId = () => {
    try {
        if (window.sessionStorage) {
            return sessionStorage.getItem("mov_tabID") !== null;
        }
        return null;
    }
    catch (err) {
        return null;
    }
};
/**
 * Genera un ID para la pestaña actual del navegador y lo almacena en sessionStorage.
 * @returns {string} - ID de la pestaña generado.
 */
const generateTabId = () => {
    const tabId = Date.now();
    try {
        if (window.sessionStorage) {
            sessionStorage.setItem("mov_tabID", tabId);
            return sessionStorage.getItem("mov_tabID");
        }
        return `notSupportedSessionStorage-${tabId}`;
    }
    catch (err) {
        return `notSupportedSessionStorage-${tabId}`;
    }
};
/**
 * Obtiene el ID de la pestaña actual.
 * Si no existe, genera uno y lo devuelve.
 * @returns {string} - ID de la pestaña.
 */
const getTabId = () => {
    if (existsTabId()) {
        return sessionStorage.getItem("mov_tabID");
    }
    return generateTabId();
};
exports.getTabId = getTabId;
exports.default = exports.getTabId;
//# sourceMappingURL=index.js.map